const clubesData = [
  {
    id: 1,
    nombre: "Acuitapilco",
    presidente: "Reyna Verdin",
    correo: "acuitapilco@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club1.png"),
  },
  {
    id: 2,
    nombre: "Borbollón",
    presidente: "Pedro Guzman",
    correo: "borbollon@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club2.png"),
  },
  {
    id: 3,
    nombre: "Camotlenses USA",
    presidente: "Angie Valladares",
    correo: "camotlenses_usa@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club3.png"),
  },
  {
    id: 4,
    nombre: "Compostelenses Unidos",
    presidente: "Manuel Alcantar",
    correo: "compostelenses_unidos@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club4.png"),
  },
  {
    id: 5,
    nombre: "Coras de la Virocha",
    presidente: "Liliana Garcia",
    correo: "CorasDeLaVirocha@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club5.png"),
  },
  {
    id: 6,
    nombre: "Ixtlán del Rio L.A",
    presidente: "Ignacio Valdez",
    correo: "IxtlanDelRioLA@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club6.png"),
  },
  {
    id: 7,
    nombre: "Jala de Los Ángeles",
    presidente: "Elizabeth Ruiz",
    correo: "JalaDeLosAngeles@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club7.png"),
  },
  {
    id: 8,
    nombre: "Jalco",
    presidente: "Pablo Frias",
    correo: "jalco@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club8.png"),
  },
  {
    id: 9,
    nombre: "Juan Escutia Borbollón",
    presidente: "Berenice Peña",
    correo: "JuanEscutiaBorbollon@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club9.png"),
  },
  {
    id: 10,
    nombre: "Koras de Ixtapa",
    presidente: "Juan Abel Mendez",
    correo: "KorasDeIxtapa@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club10.png"),
  },
  {
    id: 11,
    nombre: "Mi Querido San Juan",
    presidente: "Eliseo Garcia",
    correo: "MiQueridoSanJuan@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club11.png"),
  },
  {
    id: 12,
    nombre: "Orgullosamente Bahía",
    presidente: "Helly Castrellon",
    correo: "orgullosamente_bahia@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club12.png"),
  },
  {
    id: 13,
    nombre: "Puente de Camotlán",
    presidente: "Tavio Macias",
    correo: "PuenteDeCamotlan@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club13.png"),
  },
  {
    id: 14,
    nombre: "Ranchos Unidos",
    presidente: "Josefa Leon",
    correo: "ranchos_unidos@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club14.png"),
  },
  {
    id: 15,
    nombre: "Rosamorada",
    presidente: "Amanda Ruiz",
    correo: "rosamorada@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club15.png"),
  },
  {
    id: 16,
    nombre: "Ruiz",
    presidente: "Olga Guerra",
    correo: "ruiz@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club16.png"),
  },
  {
    id: 17,
    nombre: "Ruiz Rieleros USA",
    presidente: "Barbara Burgellos",
    correo: "RuizRieleros_USA@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club17.png"),
  },
  {
    id: 18,
    nombre: "San José de García",
    presidente: "Fidel Lopez",
    correo: "SanJoseDeGarcia@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club18.png"),
  },
  {
    id: 19,
    nombre: "San Pedro Lagunillas",
    presidente: "Isidro Catellon",
    correo: "SanPedroLagunillas@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club19.png"),
  },
  {
    id: 20,
    nombre: "Social Ixtlán del Río",
    presidente: "Rosie Chavez",
    correo: "Social_IxtlanDelRio@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club20.png"),
  },
  {
    id: 21,
    nombre: "Social Pericos USA",
    presidente: "Marthina",
    correo: "SocialPericos_USA@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club21.png"),
  },
  {
    id: 22,
    nombre: "Tecuala y sus Municipios",
    presidente: "Andres Estrada",
    correo: "TecualaYsusMunicipios@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club22.png"),
  },
  {
    id: 23,
    nombre: "Tuxpan",
    presidente: "Audelina Contreras",
    correo: "tuxpan@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club23.png"),
  },
  {
    id: 24,
    nombre: "Unión de Corrientes",
    presidente: "Hector Chavez",
    correo: "UnionDeCorrientes@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club24.png"),
  },
  {
    id: 25,
    nombre: "Unidos por Tetitlan",
    presidente: "Pedro Gonzalez",
    correo: "UnidosPorTetitlan@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club25.png"),
  },
  {
    id: 26,
    nombre: "Unidos por un Sayulita Mejor",
    presidente: "Jazmin Llamas",
    correo: "UnidosPorUnSayulitaMejor@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club26.png"),
  },
  {
    id: 27,
    nombre: "Xalisco",
    presidente: "Zaida Isiordia",
    correo: "xalisco@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club27.png"),
  },
  {
    id: 28,
    nombre: "Yago",
    presidente: "Margarita",
    correo: "yago@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club28.png"),
  },
  {
    id: 29,
    nombre: "Unidos por Siempre Tepic",
    presidente: "Rita Martinez",
    correo: "UnidosPorSiempreTepic@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club29.png"),
  },
  {
    id: 30,
    nombre: "Adrián Maldonado",
    presidente: "Adrián Maldonado",
    correo: "adrian_maldonado@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club30.png"),
  },
  {
    id: 31,
    nombre: "Griselda Velázquez",
    presidente: "Griselda Velazquez",
    correo: "griselda_velazquez@fenineofical.com",
    imagen: require("../imagenes/Clubs/Club31.png"),
  },
  {
    id: 32,
    nombre: "Jaime López",
    presidente: "Jaime Lopez",
    correo: "jaime_lopez@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club32.png"),
  },
  {
    id: 33,
    nombre: "Obdulio Mota",
    presidente: "Obdulio Mota",
    correo: "obdulio_mota@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club33.png"),
  },
  {
    id: 34,
    nombre: "Paloma de Tlaxca",
    presidente: "Paloma de Tlaxca",
    correo: "PalomaDeTlaxca@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club34.png"),
  },
  {
    id: 35,
    nombre: "Onofre Silva",
    presidente: "Onofre Silva",
    correo: "onofre_silva@fenineoficial.com",
    imagen: require("../imagenes/Clubs/Club35.png"),
  },
];

export default clubesData;
